<template>
    <Modal>
        <div class="p-grid p-fluid p-justify-end">

            <div class="p-col-12">
                <AutoComplete v-model="selectedValue"
                              field="label"
                              class="p-mb-2"
                              :suggestions="filtered"
                              @complete="searchUsers($event)"
                              @keyup.enter="onSubmit"
                              :placeholder="this.$t('loginAs')"
                              autofocus
                              />
                <span class="text-red">{{ autocompleteStatusMessageKey ? $t(autocompleteStatusMessageKey) : '&nbsp;' }}</span>
            </div>
            <div class="p-col-6">
                <Button
                        id="continue"
                        style="margin-top: 4em;"
                        :label="this.$t('continue')"
                        @click="onSubmit()"
                        />
            </div>
        </div>
    </Modal>
</template>

<script>
    import Modal from "@/components/Shared/Modal";
    import Button from "primevue/button";
    import UserSession from "@/service/UserSession";
    import AuthenticationService from "@/service/AuthenticationService";
    import UserService from "@/service/UserService";

    export default {
        components: {
            Modal,
            Button
        },
        data() {
            const userSession = new UserSession(localStorage);

            return {
                userSession: userSession,
                authenticationService: new AuthenticationService(userSession),
                userService: new UserService(),
                filtered: null,
                selectedValue: null,
                filterQueryTimeout: null,
                autocompleteStatusMessageKey: null,
            };
        },
        methods: {
            searchUsers: function (event) {

                if (this.filterQueryTimeout) {
                    clearTimeout(this.filterQueryTimeout);
                }

                this.filterQueryTimeout = setTimeout(() => {

                    const nameQuery = event.query.toLowerCase();
                    if (nameQuery.length) {
                        this.fetchUsers(nameQuery);
                        this.filterQueryTimeout = null;
                    }

                }, 600);
            },
            onSubmit: function () {
                const userId = this.selectedValue && this.selectedValue.id || this.userSession.userId;

                this.authenticationService.impersonate(userId, this.$route.query.continue)
                    .then(url => location.href = url);
            },
            fetchUsers: function (nameContains) {
                this.autocompleteStatusMessage = null
                this.userService.getSummary(nameContains)
                    .then(response => {
                        if (!response.length) {
                            this.autocompleteStatusMessageKey = 'noUsersFound';
                        } else {
                            this.autocompleteStatusMessageKey = null;
                        }

                        this.filtered = response.map(user => ({
                            user: user,
                            label: `${user.name} [${user.username}]`,
                            id: user.id
                        }));
                    })
                    .catch(() => {
                        this.autocompleteStatusMessageKey = 'somethingWentWrong';
                        this.filtered = [];
                    });
            }
        }
    }
</script>

<style lang="scss">
    .text-red {
        color: var(--red-600);
    }
</style>

<i18n lang="yaml" locale="en">
    loginAs: "Choose user to login as"
    noUsersFound: "No users found"
</i18n>

<i18n lang="yaml" locale="dk">
    loginAs: "Vælg bruger til at logge ind som"
</i18n>
